<template>
    <div>
        <rkm-form ref="RkmForm">
            <rkm-row v-if="data.model.avaliacaoAntropometrica.massa">
                <rkm-col>
                    <rkm-alert show>
                        Peso do paciente: {{ data.model.avaliacaoAntropometrica.massa }} {{ getUnidadeMedida(data.model.avaliacaoAntropometrica.massaUnidadeMedidaId).sigla }}
                    </rkm-alert>
                </rkm-col>
            </rkm-row>

            <rkm-area
                type="section"
                title="Dados gerais da prescrição"
            >
                <rkm-row>
                    <rkm-col>
                        <rkm-row>
                            <rkm-col>
                                <rkm-form-radio-group
                                    :validations="validations.doseUnica"
                                    v-model="model.doseUnica"
                                >
                                    <rkm-form-radio :value="false">Frequência</rkm-form-radio>
                                    <rkm-form-radio :value="true">Dose Única</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-input
                                    :disabled="isDoseUnica"
                                    :validations="validations.frequenciaQuantidadeVezes"
                                    name="Frequência"
                                    type="number"
                                    v-model="model.frequenciaQuantidadeVezes"
                                >
                                    <rkm-input-group-append slot="append">
                                        <rkm-input-group-text>
                                            {{ parseInt(model.frequenciaQuantidadeVezes) > 1 ? 'aplicações' : 'aplicação' }}
                                        </rkm-input-group-text>
                                    </rkm-input-group-append>
                                </rkm-form-input>
                            </rkm-col>
                        </rkm-row>
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :disabled="isDoseUnica"
                            :validations="validations.frequenciaTempo"
                            inputGroupClass="flex-nowrap"
                            name="Tempo da frequência"
                            label="Uma a cada"
                            type="number"
                            v-model="model.frequenciaTempo"
                        >

                            <rkm-input-group-append slot="append">
                                <rkm-input-group-text>
                                    <rkm-form-radio-group
                                        :disabled="isDoseUnica"
                                        class="align-self-center text-nowrap pl-2"
                                        v-model="model.frequenciaMedidaTempoId"
                                    >
                                        <rkm-form-radio :value="enums.medidaTempo.MINUTOS">
                                            {{ getUnidadesMedidaTempo(enums.medidaTempo.MINUTOS).nome }}
                                        </rkm-form-radio>

                                        <rkm-form-radio :value="enums.medidaTempo.HORAS">
                                            {{ getUnidadesMedidaTempo(enums.medidaTempo.HORAS).nome }}
                                        </rkm-form-radio>
                                    </rkm-form-radio-group>
                                </rkm-input-group-text>
                            </rkm-input-group-append>

                        </rkm-form-input>
                    </rkm-col>

                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-textarea
                            :validations="validations.observacoes"
                            label="Observações"
                            v-model="model.observacoes"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area
                title="Medicamentos cadastrados"
                type="section"
            >
                <template slot="trailing">
                    <rkm-button
                        @click="openModalMedicamento(null, null)"
                        color="primary"
                        small
                    >
                        <rkm-icon icon="plus" /> Novo medicamento
                    </rkm-button>
                </template>

                <rkm-table
                    :fields="form.medicamentoFields"
                    :items="model.medicamentos"
                    hide-filters
                    hide-pagination
                    tag="div"
                >
                    <template v-slot:cell(index)="row">
                        {{row.index}}
                    </template>

                    <template v-slot:cell(quantidade)="row">

                        <template v-if="row.item">
                            {{ row.item.quantidade.toString().replace('.', ',') }}
                        </template>
                    </template>

                    <template v-slot:cell(actions)="row">
                        <rkm-button
                            :disabled="Number.isInteger(model.id)"
                            @click.stop="openModalMedicamento(row.item, row.index)"
                            color="primary"
                            title="Editar"
                            small
                        >
                            <rkm-icon icon="pen" />
                        </rkm-button>

                        <rkm-button
                            :disabled="Number.isInteger(model.id)"
                            @click.stop="deleteModalMedicamento(row.index)"
                            color="danger"
                            title="Excluir"
                            small
                        >
                            <rkm-icon icon="trash" />
                        </rkm-button>
                    </template>
                </rkm-table>
            </rkm-area>
        </rkm-form>

        <rkm-modal
            ref="MedicamentoModal"
            title="Medicamento"
        >
            <rkm-form ref="MedicamentoForm">
                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-input-autocomplete
                            @select="form.medicamento.unidadeMedidaId = $event.unidadeMedidaId"
                            :searchFields="fields.medicamentos"
                            :repository="repositories.medicamentos"
                            :request-query-string-params="{
                                exibir_prescricao_interna: true,
                            }"
                            :validations="validations.medicamento"
                            label="Medicamento"
                            v-model="form.medicamento.medicamento"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-input
                            :validations="validations.quantidade"
                            label="Quantidade"
                            type="number"
                            step="0.1"
                            v-model="form.medicamento.quantidade"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">

                        <rkm-form-select
                            :options="data.form.unidadesMedidaMedicamento"
                            :validations="validations.unidadeMedida"
                            label="Unidade de medida"
                            text-field="sigla"
                            v-model="form.medicamento.unidadeMedidaId"
                            value-field="id"
                            show-default-option
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            disabled
                            label="Forma farmacêutica"
                            v-model="form.medicamento.formaFarmaceuticaNome"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-textarea
                            :maxlength="validations.administracao.max"
                            :rows="4"
                            :validations="validations.administracao"
                            label="Administrar"
                            placeholder="Ex: Administrar 20 mg lentamente"
                            v-model="form.medicamento.administracao"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-form>

            <template #footer>
                <rkm-row>
                    <rkm-col class="text-right">
                        <rkm-button
                            @click="hideModalMedicamento"
                            color="secondary"
                        >
                            Voltar
                        </rkm-button>
                        <rkm-button
                            v-if="form.medicamento.index >= 0"
                            @click="editarMedicamento(form.medicamento.index)"
                            color="primary"
                        >
                            Salvar
                        </rkm-button>

                        <rkm-button
                            v-else
                            @click="adicionarMedicamento"
                            color="primary"
                        >
                            Adicionar novo medicamento
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </template>
        </rkm-modal>
    </div>
</template>

<script>
// Enums.
import medidaTempo from '@/enums/cadastro/medidaTempo'
import unidadeMedida from '@/enums/cadastro/unidadeMedida'

// Filters.
import formats from '@/filters/formats'

// Mixins.
import { repository, object } from '@/mixins'

export default {
    computed: {
        isDoseUnica() {
            return this.model.doseUnica
        },
        validations() {
            return {
                doseUnica: {
                    required: true,
                },
                frequenciaQuantidadeVezes: {
                    required: !this.model.doseUnica,
                    numeric: true,
                    min_value: 1,
                    max_value: 999
                },
                frequenciaTempo: {
                    required: !this.model.doseUnica,
                    numeric: true,
                    min_value: 1,
                    max_value: 999
                },
                frequenciaMedidaTempoId: {
                    required: !this.model.doseUnica
                },
                observacoes: {
                    max: 250,
                },
                medicamento: {
                    required: true,
                },
                quantidade: {
                    required: true,
                    min: 0.1,
                    min_value: 0.1,
                    max_value: 99
                },
                unidadeMedida: {},
                administracao: {
                    max: 3000
                },
            }
        },
    },
    created() {
        this.repositories.medicamentos = this.getConectaSusRepository('cadastro.medicamento.medicamento')
    },
    data: () => ({
        enums: {
            medidaTempo,
            unidadeMedida,
        },
        fields: {
            medicamentos: [
                { key: 'nome', searchable: true }
            ],
        },
        form: {
            medicamentoClone: null,
            medicamentoFields: [
                { key: 'medicamento.nome', label: 'Medicamento' },
                { key: 'quantidade', label: 'Quantidade', class: 'col-min' },
                { key: 'unidadeMedidaSigla', label: 'Unidade de medida', class: 'col-min' },
                { key: 'formaFarmaceuticaNome', label: 'Forma Farmacêutica' },
                { key: 'administracao', label: 'Administrar' },
                { key: 'actions', label: 'Ações', class: 'col-min' },
            ],
            medicamento: {
                medicamento: null,
                unidadeMedidaId: null,
                formaFarmaceuticaNome: null,
                quantidade: null,
                administracao: null
            },
        },
        repositories: {},
    }),
    filters: {
        ...formats,
    },
    methods: {
        getUnidadesMedidaTempo(id) {
            return this.data.form.unidadesMedidaTempo.filter(medida => medida.id == id)[0]
        },
        getUnidadeMedida(id) {
            return this.data.form.unidadesMedidaMedicamento.find(unidade => unidade.id === id)
        },
        editarMedicamento(index) {
            this.$refs.MedicamentoForm.validate().then(response => {
                if (response && this.verificarMedicamentoDuplicidade()) {
                    Object.assign(this.model.medicamentos[index], {
                        ...this.form.medicamento,
                        unidadeMedidaSigla: this.getSafely(() => this.data.form.unidadesMedidaMedicamento
                            .find(u => u.id === this.form.medicamento.unidadeMedidaId).sigla)
                    })

                    this.form.medicamento.medicamento = null
                    this.hideModalMedicamento()
                }
            });

        },
        adicionarMedicamento() {
            this.$refs.MedicamentoForm.validate().then(response => {

                if (response && this.verificarMedicamentoDuplicidade() && this.verificaMedicamentoPrescricao()) {
                    this.form.medicamento.index = this.model.medicamentos.length

                    this.model.medicamentos.push({
                        ...this.form.medicamento,
                        unidadeMedidaSigla: this.getSafely(() => this.data.form.unidadesMedidaMedicamento
                            .find(u => u.id === this.form.medicamento.unidadeMedidaId).sigla)
                    })

                    this.form.medicamento = {...this.form.medicamentoClone}
                    this.form.medicamento.medicamento = null
                    this.$refs.MedicamentoForm.resetValidator()
                }
            });
        },
        verificaMedicamentoPrescricao() {

            const existePrescricao = this.data.model.prescricoesInternas.some(prescricao => {
                return prescricao.medicamentos.some(med => {
                    return med.medicamento.id === this.form.medicamento.medicamento.id;
                });
            });

            if (existePrescricao) {
                const confirmAddMedicamento = async () => {

                    this.model.medicamentos.push({
                        ...this.form.medicamento,
                        unidadeMedidaSigla: this.getSafely(() => this.data.form.unidadesMedidaMedicamento
                            .find(u => u.id === this.form.medicamento.unidadeMedidaId).sigla)
                    })

                    this.form.medicamento = {...this.form.medicamentoClone}
                    this.form.medicamento.medicamento = null
                    this.$refs.MedicamentoForm.resetValidator()

                    return true;
                };

                const cancelAddMedicamento = async () => {
                    return false;
                };

                const msg = `O medicamento <strong>${this.form.medicamento.medicamento.nome}</strong> já foi ` +
                    `prescrito em uma prescrição deste mesmo atendimento. Deseja realmente continuar?`;

                this.showConfirmation(msg, confirmAddMedicamento, cancelAddMedicamento);
            }

            return !existePrescricao;
        },
        verificarMedicamentoDuplicidade() {

            if(!this.form.medicamento.medicamento.id) return false
                const duplicado = this.model.medicamentos.find(item => {

                if (item.index != this.form.medicamento.index) {
                    return item.medicamento.id === this.form.medicamento.medicamento.id
                }

                return false
            })

            if (duplicado) {
                this.createNotification({
                    type: 'alert',
                    color: 'danger',
                    title: 'Ação não permitida',
                    message: `Este medicamento já existe nesta prescrição`
                })
            }

            return !duplicado
        },
        openModalMedicamento(item, index) {
            if(index === null){
                this.form.medicamento = {...this.form.medicamentoClone}
            }else{
                item.index = index;
                Object.assign(this.form.medicamento, item)
            }

            this.$refs.MedicamentoModal.show()
        },
        hideModalMedicamento() {
            this.$refs.MedicamentoModal.hide()
        },
        deleteModalMedicamento(index) {
            const destroy = () => new Promise(resolve => {
                resolve(this.model.medicamentos.splice(index, 1))
            })

            this.showDeleteConfirmation('Tem certeza que deseja excluir?', destroy)
        },
        handleDestroy(item) {
            const destroy = () => new Promise(resolve => {
                resolve(this.model.prescricoesInternas.splice(this.model.prescricoesInternas.findIndex(servicoenfermagem => servicoenfermagem.id === item.id), 1))
            })

            this.showDeleteConfirmation('Tem certeza que deseja excluir?', destroy)
        },
        save() {
            this.hideModalMedicamento()

            this.$nextTick(() => {
                this.$refs.RkmForm.validate().then(response => {
                    if (response) {

                        if (!this.model.medicamentos.length) {
                            this.createNotification({
                                type: 'alert',
                                color: 'danger',
                                title: 'Ação não permitida',
                                message: `Informe pelo menos um medicamento para esta prescrição`
                            })
                        } else {
                            if (this.model.id) {
                                const index = this.data.model.prescricoesInternas.findIndex(item => item.id === this.model.id)
                                Object.assign(this.data.model.prescricoesInternas[index], this.model)
                            } else {
                                this.model.id = this.uniqueId('pronto-atendimento-atendimento-medico-servicoenfermagem');
                                this.data.model.prescricoesInternas.push(this.model)
                            }

                            this.$emit('saved', this.model)
                        }
                    }
                })
            })
        },
        openMedicamento() {
            this.$refs.ModalMedicamento.open();
        },
    },
    mixins: [repository, object],
    mounted() {
        this.form.medicamentoClone = {...this.form.medicamento}
    },
    props: {
        data: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    watch: {
        'form.medicamento.medicamento': function (medicamento) {

            this.form.medicamento.formaFarmaceuticaNome = medicamento
                ? this.data.form.formasFarmaceutica.find(ff => ff.id === medicamento.formaFarmaceuticaId).nome
                : null
        },
        'model.doseUnica': function (isDoseUnica) {

            if (isDoseUnica) {

                this.model.frequenciaQuantidadeVezes = null
                this.model.frequenciaTempo = null
            }
        }
    }
}
</script>